import React, { useEffect } from "react";
import InPlayer from "../backend/inplayer";

const User = (props) => {
  useEffect(() => {
    if (InPlayer.Account.isAuthenticated()) {
      console.log(InPlayer.Account.isAuthenticated());
    } else {
      console.log("Login Please");
    }
  });

  const logIn = (event) => {
    event.preventDefault();
    InPlayer.Account.signIn({
      email: "jvjijith@live.com",
      password: "jithu927927",
      clientId: "556f2de2-6d52-42c3-a76d-9a91576b0548",
      grantType: "password",
    })
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {});
  };

  const logOut = (event) => {
    event.preventDefault();
    InPlayer.Account.signOut().then((data) => {
      console.log("");
    });
  };

  return (
    <div className="text-center" style={{ paddingTop: "120px" }}>
      <button onClick={logOut}>LogOut</button>

      <button onClick={logIn}>Login</button>
    </div>
  );
};

export default User;
